import { inject, Injectable, Type } from '@angular/core';
import {
  AutomationConditionType,
  AutomationRuleGroupBoolean,
  AutomationRuleType,
  IAutomationRule,
  IAutomationRuleGroup,
} from '@kinet-open-network/shared/data-access/model';
import { AUTOMATION_BUILDER_CONFIG } from '../automation-builder.config';
import { generateAutomationId } from '../automation-id-generator.util';
import RULES_MAP from './rules';
import { RuleComponent } from './rules/abstract-rule.component';

@Injectable()
export class AutomationConditionService {
  readonly #config = inject(AUTOMATION_BUILDER_CONFIG, { optional: true });

  createRule(type?: AutomationRuleType): Partial<IAutomationRule> {
    return {
      id: this.generateId(),
      type: AutomationConditionType.Rule,
      rule: type,
      value: null,
    };
  }

  createRuleGroup(): IAutomationRuleGroup {
    return {
      id: this.generateId(),
      collapsed: false,
      type: AutomationConditionType.Group,
      boolean: AutomationRuleGroupBoolean.And,
      children: [],
    };
  }

  getComponentForType<T extends AutomationRuleType>(
    type?: T,
  ): Type<RuleComponent> {
    if (!type) {
      return RuleComponent;
    }
    const merged = { ...RULES_MAP, ...this.#config?.conditions };
    return merged[type] || RuleComponent;
  }

  generateId(): string {
    return generateAutomationId();
  }
}
